import { render } from "./ModalThanks.vue?vue&type=template&id=f458028e"
import script from "./ModalThanks.vue?vue&type=script&lang=js"
export * from "./ModalThanks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__